export default (gaugeData, gaugeColor) => {
  const option = {
    color: gaugeColor,
    series: [
      {
        type: 'pie',
        colorBy: 'data',
        radius: ['50%', '70%'],
        avoidLabelOverlap: false,
        label: {
          show: false,
          position: 'center',
        },
        emphasis: {
          label: {
            show: false,
          },
          scale: true,
          scaleSize: 1.5,
        },
        labelLine: {
          show: false,
        },
        data: gaugeData,
      },
    ],
  };

  return option;
};
